import { OrganizationStatuses } from '../models/organization';
import { Locales } from './locales';

export const OrganizationStatusesLocalization = {
  [Locales.ru]: {
    [OrganizationStatuses.active]: 'Активен',
    [OrganizationStatuses.blocked]: 'Заблокирован',
    [OrganizationStatuses.not_confirmed]: 'Не подтвержден'
  },
  [Locales.en]: {
    [OrganizationStatuses.active]: 'Active',
    [OrganizationStatuses.blocked]: 'Blocked',
    [OrganizationStatuses.not_confirmed]: 'Not confirmed',
  }
};
